import React, {useState, useEffect, useContext} from 'react';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
import {canvasFormBannerTypes, clientSideEventNames, documentTypes} from '../../../util/uiconstants';
import CanvasFormSnapshotLeftSideView from '../../Common/CanvasForm/CanvasFormSnapshotLeftSideView';
import CanvasFormSnapshotRightSideView from '../../Common/CanvasForm/CanvasFormSnapshotRightSideView';
import {DocumentEngagementIdContext, DocumentTypeIdContext} from '../../Main/Forms/CanvasFormContainer';
import CanvasBanner from '../CanvasForm/Banner/CanvasBanner';
import DraggableComments from '../EngagementComment/DraggableComments';
import $ from 'jquery';
import DraggableGuidance from './Bodies/Common/DraggableGuidance';
import {useUserPreferences} from '../../../util/customHooks';
import {getTaskDocumentByDocumentId} from '../../../selectors/Ares/selectors';

export default function CanvasFormSnapshotContainer(props) {
	const {isSnapshot, formData, engagementId, documentId} = props;

	const [sharedMessageVisible, setSharedMessageVisible] = useState(false),
		[showCommentsModal, setShowCommentsModal] = useState(false),
		[bodyId, setBodyId] = useState(undefined),
		[commentsDocumentTypeId, setCommentsDocumentTypeId] = useState(undefined),
		[isExternallyShared, setIsExternallyShared] = useState(false),
		[showGuidanceModal, setShowGuidanceModal] = useState(false),
		[guidanceDetails, setGuidanceDetails] = useState([]),
		[guidanceId, setGuidanceId] = useState(0);

	const document = useSelector((state) => getTaskDocumentByDocumentId(state, documentId));
	const documentEngagementId = useContext(DocumentEngagementIdContext),
		documentTypeId = useContext(DocumentTypeIdContext),
		userPreferences = useUserPreferences();

	const closeCommentsModal = () => {
		setShowCommentsModal(false);
		$('span[id^=cmtIcon]').removeClass('active');
		$('.comments-icon.active').removeClass('active');
	};

	const showComments = (event) => {
		setBodyId(event.detail.bodyId);
		setShowCommentsModal(event.detail.show);
		setCommentsDocumentTypeId(event.detail.documentTypeId);
	};

	const openGuidanceModal = (event) => {
		setShowGuidanceModal(event.detail.show);
		setGuidanceDetails(event.detail.guidanceDetails);
		setGuidanceId(event.detail.guidanceId);
	};

	const closeGuidanceModal = () => {
		setShowGuidanceModal(false);
	};

	useEffect(() => {
		if (documentEngagementId !== undefined) {
			if (Number(engagementId) !== Number(documentEngagementId)) {
				setSharedMessageVisible(true);
			}
		}
	}, [documentEngagementId]);

	useEffect(() => {
		if (!userPreferences.isGuestUser && document?.isSharedExternally) {
			setIsExternallyShared(true);
		}
	}, [document]);

	useEffect(() => {
		window.addEventListener(clientSideEventNames.showCommentsModal, showComments);
		window.addEventListener(clientSideEventNames.closeCommentsModal, closeCommentsModal);
		window.addEventListener(clientSideEventNames.showGuidanceModal, openGuidanceModal);
		window.addEventListener(clientSideEventNames.closeGuidanceModal, closeGuidanceModal);
		return () => {
			window.removeEventListener(clientSideEventNames.showCommentsModal, showComments);
			window.removeEventListener(clientSideEventNames.closeCommentsModal, closeCommentsModal);
			window.removeEventListener(clientSideEventNames.showGuidanceModal, openGuidanceModal);
			window.removeEventListener(clientSideEventNames.closeGuidanceModal, closeGuidanceModal);
		};
	}, []);

	return (
		<StyledCanvasFormChanges className="sectionCanvasForm CanvasFormChanges">
			{documentTypeId === documentTypes.INDEPENDENCEFORMINDIVIDUAL && (
				<CanvasBanner documentId={documentId} bannerType={canvasFormBannerTypes.independence} />
			)}
			{sharedMessageVisible && <CanvasBanner documentId={documentId} bannerType={canvasFormBannerTypes.shared} />}
			{isExternallyShared && (
				<CanvasBanner documentId={documentId} bannerType={canvasFormBannerTypes.isSharedExternal} />
			)}
			{documentTypeId === documentTypes.PROFILEV2 && (
				<CanvasBanner documentId={documentId} bannerType={canvasFormBannerTypes.profileV2} />
			)}
			<section className="CanvasFormChangesContent">
				<CanvasFormSnapshotLeftSideView
					isSnapshot={isSnapshot}
					formData={formData}
					engagementId={engagementId}
					documentId={documentId}
				/>
				<CanvasFormSnapshotRightSideView
					isSnapshot={-1}
					formData={formData}
					engagementId={engagementId}
					documentId={documentId}
				/>
			</section>
			{showCommentsModal && (
				<DraggableComments show={showCommentsModal} bodyId={bodyId} documentTypeId={commentsDocumentTypeId} />
			)}
			{showGuidanceModal && (
				<DraggableGuidance show={showGuidanceModal} guidanceDetails={guidanceDetails} guidanceId={guidanceId} />
			)}
		</StyledCanvasFormChanges>
	);
}

const StyledCanvasFormChanges = styled.section`
	display: flex;
	flex-direction: column;
	flex: 1;
	height: 100%;
	padding: 0;
	overflow-y: hidden;
	.CanvasFormChangesContent {
		display: flex;
		height: 100%;
		margin: var(--px-20) var(--px-20) 0 var(--px-20);
		overflow-y: auto;
		.section-body {
			background-color: transparent !important;
			position: relative;
			.RiskInputField {
				.inputField {
					width: 100% !important;
				}
			}
			.DraggableGuidance {
				position: fixed;
				left: 13%;
			}
		}
	}
`;
